/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { FormResolveType } from "../../redux/AppStateSlice";
import {
  FormInput, Button,
  ButtonSize,
  MITheme
} from "@spectrumselect/mi-ui-react";
import { ErrorMessage } from "../../components/errorMessage/ErrorMessage";
import "../collectUsernameForm/CollectUsernameForm.scss"
import { MAILTORESETPASSWORD } from "../../utils/constants";

interface ChangePasswordFormProps {
  errorMessage?: string;
  resolve?: FormResolveType;
  brand?: string;
  invokeChangePasswordJourney(username: string): void;
  tenant: string;
  goToUsernameForm(): void;
  username? : string

}

export const ChangePasswordForm: React.FunctionComponent<ChangePasswordFormProps> = (props) => {
  window.localStorage.setItem("pathName", ""); // TODO: find out why
  const [userId, setUserId] = useState(props?.username || "");

  const onSubmitButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    props.invokeChangePasswordJourney(userId);
  }
  
  const onCancelButtonClick = () => {
    props.goToUsernameForm();
  }

  return (
    <form className="CollectUsernameForm App_formInputGroup">
      <h1 className="App_pageTitle">Change password</h1>
      <p className="App_formDesc">Changing your password is easy. Please click the submit button below to continue.</p>
      {props.errorMessage && <ErrorMessage>{props.errorMessage}</ErrorMessage>}
      <div className="App_formInputGroup">
        <FormInput
          id="userID"
          className="input100"
          placeholder="Username"
          disabled={userId !== ""}
          label=""
          type="email"
          value={userId}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => setUserId(event.target.value)}
          autoComplete="username"
        // theme={MITheme.dark}
        />
      </div>
      <div className="App_formButtonGroup">
        <a href="javascript:void(0)" className="UsernameForm_ResetPwdButton" onClick={onCancelButtonClick}>
          Cancel
        </a>
        <Button
          className={`login100-form-btn ${props.tenant}-btn`}
          type="submit"
          disabled={userId.length === 0}
          onClick={onSubmitButtonClick}
          theme={MITheme.dark}
          size={ButtonSize.large}
        >
          Submit
        </Button>
      </div>
      <p className="txt2 welcome-desc">Need more help logging in? Please contact our tech support team <span>(<a href={MAILTORESETPASSWORD.link}>{MAILTORESETPASSWORD.text}</a>)</span>.</p>
    </form>
  )
};
